export default __webpack_public_path__ + "static/media/prtenr.244f2f00.jpg";